const resourceName = 'https://storage.googleapis.com/ulrichlifestyle-static';
const fontsFolder = 'fonts';
const imagesFolder = 'images';

export const getFontURL = (font: string): string => {
    return `${resourceName}/${fontsFolder}/${font}`;
};

export const getImgURL = (image: string): string => {
    return `${resourceName}/${imagesFolder}/${image}`;
};

export const futura_pt_bold_ttf = getFontURL('futura-pt-bold.ttf');
export const futura_pt_bold_woff = getFontURL('futura-pt-bold.woff');
export const futura_pt_bold_woff2 = getFontURL('futura-pt-bold.woff2');
export const futura_pt_medium_ttf = getFontURL('futura-pt-medium.ttf');
export const futura_pt_medium_woff = getFontURL('futura-pt-medium.woff');
export const futura_pt_medium_woff2 = getFontURL('futura-pt-medium.woff2');
export const futura_pt_book_woff2 = getFontURL('futura-pt-book.woff2');
export const futura_pt_book_woff = getFontURL('futura-pt-book.woff');
export const futura_pt_book_ttf = getFontURL('futura-pt-book.ttf');
export const Oswald_Bold_ttf = getFontURL('Oswald-Bold.ttf');
export const Oswald_Bold_woff = getFontURL('Oswald-Bold.woff');
export const Oswald_Bold_woff2 = getFontURL('Oswald-Bold.woff2');

export const fonts = {
    futura_pt_bold_ttf: getFontURL('futura-pt-bold.ttf'),
    futura_pt_bold_woff: getFontURL('futura-pt-bold.woff'),
    futura_pt_bold_woff2: getFontURL('futura-pt-bold.woff2'),
    futura_pt_medium_ttf: getFontURL('futura-pt-medium.ttf'),
    futura_pt_medium_woff: getFontURL('futura-pt-medium.woff'),
    futura_pt_medium_woff2: getFontURL('futura-pt-medium.woff2'),
    futura_pt_book_woff2: getFontURL('futura-pt-book.woff2'),
    futura_pt_book_woff: getFontURL('futura-pt-book.woff'),
    futura_pt_book_ttf: getFontURL('futura-pt-book.ttf'),
    Oswald_Bold_ttf: getFontURL('Oswald-Bold.ttf'),
    Oswald_Bold_woff: getFontURL('Oswald-Bold.woff'),
    Oswald_Bold_woff2: getFontURL('Oswald-Bold.woff2'),
};
export const ImgProduct = getImgURL('Product.svg');
export const ImgSides = getImgURL('Sides.svg');
export const ImgUpgrades = getImgURL('Upgrades.svg');
export const ImgColors = getImgURL('Colors.svg');
export const ImgTutorial = getImgURL('Tutorial.svg');

export const ImgUpgradesActive = getImgURL('ActiveUpgrades.svg');
export const ImgProductActive = getImgURL('ActiveProduct.svg');
export const ImgSidesActive = getImgURL('ActiveSides.svg');
export const ImgColorsActive = getImgURL('ActiveColors.svg');
export const ImgTutorialActive = getImgURL('Tutorial.svg');

export const ImgNone = getImgURL('none.svg');
export const ImgPcVerticalTri = getImgURL('PcVerticalTri.svg');
export const ImgDecorationXTrim = getImgURL('DecorationXTrim.svg');
export const ImgOctogonalTrim = getImgURL('OctogonalTrim.svg');
export const ImgAngledFrame = getImgURL('Angled%20Frame.svg');
export const ImgSquareFrame = getImgURL('Square%20Frame.svg');
export const ImgSingleDoor = getImgURL('SingleDoor.svg');
export const ImgDoubleDoor = getImgURL('DoubleDoor.svg');
export const ImgTripleDoor = getImgURL('TripleDoor.svg');
export const ImgCenterWall = getImgURL('CenterWall.svg');
export const ImgCenterBetween = getImgURL('CenterBetween.svg');
export const ImgEquallySpace = getImgURL('EquallySpace.svg');

export const ImgPorchSideA = getImgURL('porchSideA.svg');
export const ImgPorchSideAActive = getImgURL('porchSideA_active.svg');
export const ImgPorchSideB = getImgURL('porchSideB.svg');
export const ImgPorchSideBActive = getImgURL('porchSideB_active.svg');
export const ImgPorchSideC = getImgURL('porchSideC.svg');
export const ImgPorchSideCActive = getImgURL('porchSideC_active.svg');
export const ImgPorchSideD = getImgURL('porchSideD.svg');
export const ImgPorchSideDActive = getImgURL('porchSideD_active.svg');
export const TutorialImg01 = getImgURL('tutorial_img_step_1.png');
export const TutorialImg02 = getImgURL('tutorial_img_step_2.png');
export const TutorialImg03 = getImgURL('tutorial_img_step_3.png');
export const TutorialImg04 = getImgURL('tutorial_img_step_4.png');
export const TutorialImg05 = getImgURL('tutorial_img_step_5.png');
export const TutorialImgMob01 = getImgURL('tutorial_img_step_mob_1.png');
export const TutorialImgMob02 = getImgURL('tutorial_img_step_mob_2.png');
export const TutorialImgMob03 = getImgURL('tutorial_img_step_mob_3.png');
export const TutorialImgMob04 = getImgURL('tutorial_img_step_mob_4.png');
export const TutorialImgMob05 = getImgURL('tutorial_img_step_mob_5.png');

export const ImgShedTripleDoor = getImgURL('ShedTripleDoor.svg');
export const ImgLeftHandInswingDD = getImgURL('Left%20Hand%20Inswing%20DD.svg');
export const ImgLeftHandInswing = getImgURL('Left%20Hand%20Inswing.svg');
export const ImgRightHandInswingDD = getImgURL('Right%20Hand%20Inswing%20DD.svg');
export const ImgRightHandInswing = getImgURL('Right%20Hand%20Inswing.svg');
export const ImgLeftHandOutswingDD = getImgURL('Left%20Hand%20Outswing%20DD.svg');
export const ImgLeftHandOutswing = getImgURL('Left%20Hand%20Outswing.svg');
export const ImgRightHandOutswingDD = getImgURL('Right%20Hand%20Outswing%20DD.svg');
export const ImgRightHandOutswing = getImgURL('Right%20Hand%20Outswing.svg');
export const ImgDoubleDoorOutside = getImgURL('DoubleDoorOutside.svg');
export const ImgDoubleDoorInside = getImgURL('DoubleDoorInside.svg');

export const ImgWebLoading_Slides_1 = getImgURL('WebLoading_Slides_1.png');
export const ImgWebLoading_Slides_2 = getImgURL('WebLoading_Slides_2.png');
export const ImgWebLoading_Slides_3 = getImgURL('WebLoading_Slides_3.png');

export const ImgLogo = getImgURL('Logo.png');

export const ImgTexan = getImgURL('Texan.png');
export const ImgRancher = getImgURL('Rancher.png');
export const ImgHeritage = getImgURL('Heritage.png');
export const ImgRetreat = getImgURL('Retreat.png');
export const ImgWorkshop = getImgURL('Workshop.png');
export const ImgGardenCottage = getImgURL('GardenCottage.png');
export const ImgModernStudio = getImgURL('ModernStudio.png');
export const ImgLeanTo = getImgURL('LeanTo.png');
export const ImgCabana = getImgURL('Cabana.png');
export const ImgByler = getImgURL('Byler.png');
export const ImgVictorianCottage = getImgURL('VictorianCottage.png');
export const ImgCapeCottage = getImgURL('CapeCottage.png');
export const ImgHideaway = getImgURL('Hideaway.png');
